// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('supplier.management', {
    url: '/management',
    templateUrl: 'main/supplier/management/management.tpl.html',
    controller: 'SupplierManagementController as vm',
  });
};

class SupplierManagementController {
  constructor($rootScope, supplier) {
    'ngInject';
    this.supplier = supplier;
    $rootScope.pageTitle = `${supplier.name || ''} - Management`;
  }
}

angular
  .module('main.supplier.management', [])
  .config(config)
  .controller('SupplierManagementController', SupplierManagementController);
